<script lang="ts" setup>
/**
 * Shared "First name" / "Last name" row used in the ProfileView and (via UserIdentityFields) the CreateTeacher and StudentsView forms.
 */
defineProps<{
  errors: { firstName?: string; lastName?: string }
  firstNameAttrs?: Record<string, unknown>
  lastNameAttrs?: Record<string, unknown>
}>()

const firstName = defineModel<string | undefined>('firstName', { required: true })
const lastName = defineModel<string | undefined>('lastName', { required: true })
</script>

<template>
  <v-row>
    <v-col md="3">
      <v-text-field
        v-model="firstName"
        v-bind="firstNameAttrs"
        :error-messages="errors.firstName"
        label="First name"
        variant="underlined"
      />
    </v-col>
    <v-col md="3">
      <v-text-field v-model="lastName" v-bind="lastNameAttrs" :error-messages="errors.lastName" label="Last name" variant="underlined" />
    </v-col>
  </v-row>
</template>
